import {
  SET_SCHEDULE_POINT_OF_SALE_CONFIGURATIONS_LIST_DATA,
  OPEN_SCHEDULE_POINT_OF_SALE_CONFIGURATION_FORM_MODAL,
  CLOSE_SCHEDULE_POINT_OF_SALE_CONFIGURATION_FORM_MODAL,
  SET_CATEGORIES_IN_SCHEDULE_POINT_OF_SALE_CONFIGURATION_FORM_MODAL
} from '../constants/schedule_point_of_sale_configuration_constants';
import { sendRequest, completeRequest } from './request_state';
import { serverStatusError, newAlert } from './alert_actions';
import {
  listSanitizer,
  createSanitizer,
  updateSanitizer,
  categoriesSanitizer
} from '../helpers/sanitizers/schedulePointOfSaleConfigurationSanitizer';
import RequestServiceNode from '../services/request_service';
import { stringifyQuery } from '../helpers/parseQuerystring';
import { history } from '../helpers/history';

const requestServiceNode = new RequestServiceNode('node');

export const fetchSchedulePointOfSaleConfigurationList = params => async dispatch => {
  dispatch(sendRequest('SchedulePointOfSaleConfigurationList'));
  history.replace(
    `/schedule-point-of-sales-configurations?${stringifyQuery(params)}`
  );

  try {
    const payload = await requestServiceNode.get(
      'schedule-point-of-sale-configurations',
      listSanitizer(params)
    );

    dispatch(setSchedulePointOfSaleConfigurationListData(payload));
  } catch (errors) {
    dispatch(serverStatusError(errors));
  } finally {
    dispatch(completeRequest('SchedulePointOfSaleConfigurationList'));
  }
};

export const createSchedulePointOfSaleConfiguration = params => async dispatch => {
  dispatch(sendRequest('SchedulePointOfSaleConfigurationCreate'));
  try {
    await requestServiceNode.post(
      'schedule-point-of-sale-configurations',
      createSanitizer(params.fields)
    );
    dispatch(_closeSchedulePointOfSaleConfigurationFormModal());
    await fetchSchedulePointOfSaleConfigurationList({
      page: 1,
      rowsPerPage: params.rowsPerPage
    })(dispatch);
    dispatch(
      newAlert(
        'success',
        's',
        'Configuracion de punto de venta creada correctamente'
      )
    );
  } catch (errors) {
    const e = await errors.json();

    if (e.statusCode && e.statusCode === 403) {
      dispatch(
        newAlert(
          'error',
          'ERROR:',
          'No tienes permisos para crear configuraciones de punto de venta'
        )
      );
    }

    if (e.errors) {
      if ('base' in e.errors) {
        dispatch(newAlert('error', 'ERROR:', e.errors.base));
      } else {
        dispatch(serverStatusError(errors));
      }
    } else {
      dispatch(serverStatusError(errors));
    }
  } finally {
    dispatch(completeRequest('SchedulePointOfSaleConfigurationCreate'));
  }
};

export const updateSchedulePointOfSaleConfiguration = params => async dispatch => {
  dispatch(sendRequest('SchedulePointOfSaleConfigurationUpdate'));
  try {
    await requestServiceNode.put(
      `schedule-point-of-sale-configurations/${params.fields.id}`,
      updateSanitizer(params.fields)
    );
    dispatch(_closeSchedulePointOfSaleConfigurationFormModal());
    await fetchSchedulePointOfSaleConfigurationList({
      page: 1,
      rowsPerPage: params.rowsPerPage
    })(dispatch);
    dispatch(
      newAlert(
        'success',
        's',
        'Configuracion de punto de venta modificada correctamente'
      )
    );
  } catch (errors) {
    const e = await errors.json();
    if (e.statusCode && e.statusCode === 403) {
      dispatch(
        newAlert(
          'error',
          'ERROR:',
          'No tienes permisos para modificar configuraciones de punto de venta'
        )
      );
    }
    if (e.errors) {
      if ('base' in e.errors) {
        dispatch(newAlert('error', 'ERROR:', e.errors.base));
      } else {
        dispatch(serverStatusError(errors));
      }
    } else {
      dispatch(serverStatusError(errors));
    }
  } finally {
    dispatch(completeRequest('SchedulePointOfSaleConfigurationUpdate'));
  }
};

export const openSchedulePointOfSaleConfigurationFormModal = () => dispatch => {
  dispatch(_openSchedulePointOfSaleConfigurationFormModal());
};

export const closeSchedulePointOfSaleConfigurationFormModal = () => dispatch => {
  dispatch(_closeSchedulePointOfSaleConfigurationFormModal());
};

export const fetchCategories = () => async dispatch => {
  dispatch(sendRequest('SchedulePointOfSaleConfigurationFormCategoriesList'));
  try {
    const payload = await requestServiceNode.get('categories/schedule');
    dispatch(setCategories(payload));
  } catch (errors) {
    dispatch(serverStatusError(errors));
  } finally {
    dispatch(
      completeRequest('SchedulePointOfSaleConfigurationFormCategoriesList')
    );
  }
};

const setSchedulePointOfSaleConfigurationListData = payload => {
  return {
    type: SET_SCHEDULE_POINT_OF_SALE_CONFIGURATIONS_LIST_DATA,
    data: payload.data,
    meta: payload.meta
  };
};

const _openSchedulePointOfSaleConfigurationFormModal = () => {
  return {
    type: OPEN_SCHEDULE_POINT_OF_SALE_CONFIGURATION_FORM_MODAL
  };
};

const _closeSchedulePointOfSaleConfigurationFormModal = () => {
  return {
    type: CLOSE_SCHEDULE_POINT_OF_SALE_CONFIGURATION_FORM_MODAL
  };
};

const setCategories = payload => {
  return {
    type: SET_CATEGORIES_IN_SCHEDULE_POINT_OF_SALE_CONFIGURATION_FORM_MODAL,
    data: categoriesSanitizer(payload.data)
  };
};
